import type { PricingContent } from "../types";
import { ES_FAQS } from "./home";

export const ES_PRICING: PricingContent = {
  seoTitle: "Precios de Crayo | Planes para cada creador",
  seoDescription:
    "Precios simples y transparentes para video corto con IA. Créditos de flujo, voces con IA, imágenes, almacenamiento y seguimiento de vistas en todos los planes.",
  name: "Precios de Crayo",
  crumb: "Precios",
  h1: "Precios",
  subheading: "Todos los planes incluyen todas las herramientas de Crayo. Elige cuánto creas.",
  faqs: [
    ...ES_FAQS,
    {
      question: "¿Cómo se compara Crayo con Opus Clip, CapCut y Submagic?",
      answer:
        "Crayo cobra un crédito de flujo por cada video terminado e incluye todas las herramientas en todos los planes. Opus Clip cobra por minuto de video fuente subido, CapCut no tiene una página pública de precios y Submagic limita créditos, cantidad de videos y minutos por video al mismo tiempo. El centro de comparaciones muestra precios y funciones con fecha y fuente para cada uno.",
      link: { href: "/compare", label: "Ver todas las comparaciones" },
    },
  ],
};
